import { Col, Row } from "antd";
import React from "react";
import { AdaptionSection } from "../../components/AdaptionSection";
import bannerImageSrc from "./banner@1x.png";
import "./index.scss";
import { IPartnerInfo } from "./model";
import SearchPartnerForm from "./SearchPartnerForm";
import { PortalPageContainer } from "../../PortalHome/components/PortalPageContainer";

const cls = "SearchPartner";
const bannerCls = "SearchPartnerBanner";

interface IProps {}

interface IState {
  isShowResult: boolean;
  partnerInfo: IPartnerInfo | null;
}

export default class SearchPartner extends React.PureComponent<IProps> {
  state: IState = {
    isShowResult: false,
    partnerInfo: null
  };

  bannerRender() {
    return (
      <div className={bannerCls}>
        <div className={`${bannerCls}-title`}>
          <AdaptionSection>
            <div className={`${bannerCls}-mainTitle`}>查找合作伙伴</div>
            <div className={`${bannerCls}-subTitle`}>1000+合作伙伴在依图</div>
          </AdaptionSection>
        </div>
        <img className={`${bannerCls}-image`} src={bannerImageSrc} />
      </div>
    );
  }

  partnerSearchResultRender() {
    const { isShowResult, partnerInfo } = this.state;

    if (!isShowResult) {
      return null;
    }

    const resultCls = "PartnerSearchResult";
    const title = partnerInfo ? "查找结果" : "未找到合作伙伴";

    return (
      <div className={resultCls}>
        <Row gutter={{ md: 16, xs: 0 }}>
          <Col xs={24} md={16}>
            <div className={`${resultCls}-title`}>{title}</div>
          </Col>

          {partnerInfo && (
            <>
              <Col xs={24} md={16}>
                <div className={`${resultCls}-companyName`}>
                  {partnerInfo.companyName}
                </div>
              </Col>
              <Col xs={24} md={16}>
                <Row>
                  <Col xs={24} md={12}>
                    <div className={`${resultCls}-item`}>
                      合作伙伴类型：
                      {`${partnerInfo.partnerType}(${partnerInfo.placeLevel})`}
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div className={`${resultCls}-item`}>
                      公司地址：{partnerInfo.registeredAddress}
                    </div>
                  </Col>
                  <Col xs={24} md={12}>
                    <div className={`${resultCls}-item`}>
                      联系电话：{partnerInfo.telephoneNum}
                    </div>
                  </Col>
                </Row>
              </Col>
            </>
          )}
        </Row>
      </div>
    );
  }

  handleShowResult = (partnerInfo: IPartnerInfo | null) => {
    this.setState({ isShowResult: true, partnerInfo });
  };

  handleFormReset = () => {
    this.setState({ isShowResult: false, partnerInfo: null });
  };

  render() {
    return (
      <PortalPageContainer>
        {this.bannerRender()}
        <AdaptionSection className={`${cls}-body`}>
          <SearchPartnerForm
            onReset={this.handleFormReset}
            handleSyncPartnerInfo={this.handleShowResult}
          />
          {this.partnerSearchResultRender()}
        </AdaptionSection>
      </PortalPageContainer>
    );
  }
}
